module.exports = "<ccd-read-order-summary-field [caseField]=\"caseField\"></ccd-read-order-summary-field>\n"